// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { ResultsBaseService } from './results-base.service';
import { environment } from '../../../../environments/environment';
import { SurveyResultsModel, ApplicationError, SurveyStatuses } from '../../../models';
import { AppService } from '../app.service';
import { ResponseBaseService } from '..';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ResultsService extends ResultsBaseService {
  constructor(
    private http: HttpClient,
    private appService: AppService,
    private translate: TranslateService,
    private responseService: ResponseBaseService
  ) {
    super();
    this.responseService.activeResponse$.subscribe(response => {
      if (!response) {
        return;
      }

      if (response.status === SurveyStatuses.completeSurvey) {
        this.loadSurveyResults(response.surveyId, true);
      }
    });
  }

  /*loadSurveyResults(identifier: string, isFullResults = false): void {
    if (!identifier) {
      return;
    }

    let url =
      environment.apiConfig.baseUrl +
      environment.apiConfig.resultsApi +
      '?id=' + `${identifier}`;
      console.log(' %%%%%%%%%%%%%%% loadSurveyResults : ' + url);
    if (isFullResults) {
      console.log(' %%%%%%%%%%%%%%% is full results = true  ');
      url += '&isFullResults=true'; 
    }
    this.http
      .get<SurveyResultsModel>(url)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._resultsModelError.bind(this))
      )
      .subscribe(results => {
        this._surveyResults$.next(results);
        this._mapScores(results);
      });
  } */


  loadSurveyResults(identifier: string, isFullResults = false): void {
    if (!identifier) {
      return;
    }

    let url =
      environment.apiConfig.baseUrl +
      environment.apiConfig.resultsApi +
      `/${identifier}`;

    if (isFullResults) {
      url += '?isFullResults=true'; 
    }
    this.http
      .get<SurveyResultsModel>(url)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._resultsModelError.bind(this))
      )
      .subscribe(results => {
        this._surveyResults$.next(results);
        this._mapScores(results);
      });
  }
 
  private _resultsModelError(err) {
    this._handleError(err);
    return of(null as SurveyResultsModel);
  }

  private _handleError(err) {
    this.appService.setLoading(false);

    let error: ApplicationError;
    if (err && err instanceof HttpErrorResponse) {
      // A client-side or network error occurred. Handle it accordingly.
      let detailedMessage = `${err.message}`;
      if (err.statusText) {
        detailedMessage += `<br/>${err.statusText}`;
      }
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        errorNumber: err.status,
        detailedMessage
      } as ApplicationError;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        originalError: err
      } as ApplicationError;
    }
    this.appService.setLastError(error);
  }
}
